import React from "react";
import PropTypes from "prop-types";
import { Tabs as MuiTabs } from "@mui/material";
import { StyledBox, StyledTab } from "./style";
import { withTranslation } from "react-i18next";

const Tabs = ({ tabs = [], values, onChange, t }) => {
  return (
    <StyledBox>
      <MuiTabs
        TabIndicatorProps={{ hidden: true }}
        value={values}
        onChange={onChange}
      >
        {tabs.map((tab, index) => (
          <StyledTab label={t(`${tab}`)} key={index} />
        ))}
      </MuiTabs>
    </StyledBox>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array,
  values: PropTypes.number,
  onChange: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(Tabs);
